<template>
  <div>
    <div class="justify-center max-w-md px-5 pt-5">
      <div class="grid grid-cols-1 gap-6">
        <div class="text-xl font-bold send-title">Request Money</div>
        <form @submit.prevent="requestMoney" v-if="!sentOff">
          <label class="block">
            <span class="text-sm font-light text-gray-700">Mobile Number</span>
            <input
              type="text"
              v-model="form.msisdn"
              class="block w-full mt-1 border-gray-300 rounded-md shadow-sm  msisdn-input focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              placeholder=""
            />
          </label>
          <label class="block mt-5">
            <span class="text-sm font-light text-gray-700">Amount</span>
            <input
              type="text"
              v-model="form.amount"
              class="block w-full mt-1 border-gray-300 rounded-md shadow-sm  amount-input focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              placeholder=""
            />
          </label>
          <div class="fixed inset-x-0 bottom-0 px-5 mb-5">
            <div>
              <button
                class="w-full px-4 py-2 font-semibold text-white bg-green-500 border border-green-500 rounded  hover:bg-green-500 hover:text-white hover:border-transparent"
              >
                REQUEST
              </button>
            </div>
            <div class="mt-5">
              <button
                @click="$router.back()"
                class="w-full px-4 py-2 font-semibold text-white bg-red-500 border border-red-500 rounded  hover:bg-red-700 hover:text-white hover:border-transparent"
              >
                BACK
              </button>
            </div>
          </div>
        </form>
        <div v-else class="mt-5">
          <div class="text-lg font-light send-summary-title">Summary</div>
          <div v-if="!isError">
            <div class="text-lg font-light send-summary-sub-title">
              Request Sent Successfully
            </div>
          </div>
          <div v-else>
            <div class="text-lg font-light send-summary-sub-title">
              Error Occurred
            </div>
          </div>
          <div class="fixed inset-x-0 bottom-0 px-5 mb-5">
            <button
              @click="$router.back()"
              class="w-full px-4 py-2 font-semibold text-white bg-red-500 border border-red-500 rounded  hover:bg-red-700 hover:text-white hover:border-transparent"
            >
              BACK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      sentOff: false,
      isError: false,
      balance: 0,
      form: {
        msisdn: "",
        amount: "",
      },
    };
  },
  methods: {
    ...mapActions(["RequestMoney"]),
    async requestMoney() {
      const DataForm = new FormData();
      DataForm.append("msisdn", this.form.msisdn);
      DataForm.append("amount", this.form.amount);
      try {
        this.sentOff = true;
        await this.RequestMoney(DataForm);
        this.showError = false;
      } catch (error) {
        this.showError = true;
      }
    },
  },
};
</script>

<style scoped>
</style>
